import { render, staticRenderFns } from "./changelog-settings.view.vue?vue&type=template&id=3d495046&scoped=true&"
import script from "./changelog-settings.view.vue?vue&type=script&lang=ts&"
export * from "./changelog-settings.view.vue?vue&type=script&lang=ts&"
import style0 from "./changelog-settings.view.vue?vue&type=style&index=0&id=3d495046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d495046",
  null
  
)

export default component.exports